import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import EndOfProjectWidget from '../../../widgets/closeProject/EndOfProjectWidget'
import EndOfProjectStaffWidget from '../../../widgets/closeProject/EndOfProjectStaffWidget'
import EndOfProjectApproveWidget from '../../../widgets/closeProject/EndOfProjectApproveWidget'
import { getEndOfProjectForm } from '../../../redux/actions/endOfProject'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'

export default function EndOfProjectApprove() {
  const [isLoading, setIsLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [projectId])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getEndOfProjectForm(proposalId)
      if (response.success) setSchemas(response.model)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} />

        {schemas?.forms?.agreementDetails && (
          <AgreementAdditionalWidgets formSchema={schemas.forms.agreementDetails} />
        )}

        {schemas?.forms?.requestNote && (
          <>
            <EndOfProjectWidget
              showCommandButton={!schemas?.forms?.requestNote?.disabled}
              schema={schemas.forms.requestNote}
              isApprove={true}
            />
            <br />
          </>
        )}

        {schemas?.forms?.requestNoteStaff && schemas?.forms?.projectEvaluation && (
          <>
            <EndOfProjectStaffWidget
              showCommandButton={!schemas?.forms?.requestNoteStaff?.disabled}
              schema={schemas?.forms?.requestNoteStaff}
              schemaEvaluate={schemas?.forms?.projectEvaluation}
              evaluateDisabled={schemas?.forms?.projectEvaluation.disabled}
            />
            <br />
          </>
        )}

        {schemas?.forms?.requestNoteApprove && (
          <>
            <EndOfProjectApproveWidget
              showCommandButton={!schemas.forms.requestNoteApprove.disabled}
              schema={schemas.forms.requestNoteApprove}
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}

const mockSchema = {
  affectedRows: 0,
  message: 'Successfully',
  success: true,
  didError: false,
  errorMessage: null,
  model: {
    header: 'ยุติโครงการ mock',
    subHeader: 'ข้อเสนอโครงการ ทดสอบโครงการปัญหา',
    forms: {
      agreementDetails: null,
      requestNote: {
        header: 'ยุติโครงการ',
        buttonText: 'ยุติโครงการ',
        note: {
          name: 'Note',
          label: 'เหตุผลการยุติโครงการ',
          value: null,
          hint: 'ระบุเหตุผลการยุติโครงการ',
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'โปรดระบุ เหตุผลการยุติโครงการ',
            },
          ],
        },
      },
    },
  },
}
